import React from 'react';
import { Text, mergeClasses } from '@fluentui/react-components';
import { Box } from '../../../../theme/fluent';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppLayoutStyles } from '../../AppLayout.styles';
import { NavigationItem } from '../../app-layout-components/navigation-item';
import { NavigationItemsProps } from './NavigationItems.types';

export const NavigationItems: React.FC<NavigationItemsProps> = ({
    dashboardItem,
    customShortcuts,
    otherNavigationItems,
    isCollapsed,
}) => {
    const { classes } = useAppLayoutStyles();
    const location = useLocation();
    const navigate = useNavigate();
    const currentPanel = new URLSearchParams(location.search).get('panel');

    return (
        <Box py="s" className={mergeClasses(classes.navItem, 'scrollable-content')}>
            {/* Dashboard - always first */}
            {dashboardItem && (
                <NavigationItem
                    item={dashboardItem}
                    isActive={location.pathname === dashboardItem.path && !currentPanel}
                    isCollapsed={isCollapsed}
                    onClick={() => navigate(dashboardItem.path)}
                />
            )}

            {/* Separator between Dashboard and Tools - only shown when collapsed */}
            {dashboardItem && customShortcuts.length > 0 && isCollapsed && (
                <Box className={classes.navItemCollapsedLine} />
            )}

            {/* Tools Section Header - only shown when expanded */}
            {!isCollapsed && customShortcuts.length > 0 && (
                <Box px="l" py="xs" className={classes.toolHeader}>
                    <Text size={200} weight="semibold" className={classes.toolHeaderText}>
                        Tools
                    </Text>
                </Box>
            )}

            {/* Custom shortcuts */}
            {customShortcuts.map((item) => {
                const isActive =
                    location.pathname === item.path &&
                    (currentPanel === item.panelId || item.activeOn?.includes(currentPanel ?? ''));

                return (
                    <NavigationItem
                        key={item.text}
                        item={item}
                        isActive={isActive || false}
                        isCollapsed={isCollapsed}
                        onClick={() => navigate(`${item.path}?panel=${item.panelId}`)}
                    />
                );
            })}

            {/* Other pages (excluding Dashboard) */}
            {otherNavigationItems.map((item) => (
                <NavigationItem
                    key={item.text}
                    item={item}
                    isActive={location.pathname === item.path}
                    isCollapsed={isCollapsed}
                    onClick={() => navigate(item.path)}
                />
            ))}
        </Box>
    );
};